import './save-indicator.styles.scss';
import React, { FC, ReactNode } from 'react';
import {Spinner} from '../ant-design/spinner';


/**
 * SaveIndicatorProps
 *
 * @memberof SaveIndicator
 */
interface SaveIndicatorProps {
    isSaving: boolean,
    unAnimatedDots?: boolean,
    hideSpinner?: boolean,
    dotStyle?: 'flashing' | 'elastic',
    savedIcon?: ReactNode,
    savingText?: string | ReactNode,
    savedText?: string | ReactNode 
};

/**
 * An saving state that will show the status of saving vs saved sates
 */
export const SaveIndicator: FC<SaveIndicatorProps> = (props) => {
    return (
        <div className={`save-indicator ${props.isSaving ? 'saving' : 'saved'}`} >
            <div className='is-saving'>
                {!props.hideSpinner && <Spinner size={'small'}/>}
                {props.savingText || 'Saving'}
                {!props.unAnimatedDots 
                ? <div className={`dot-${props.dotStyle || 'flashing'}`}></div>
                : <span style={{position:'relative', right:5}}>. . .</span>
            }
            </div>
            <div className='is-saved'>
                {props.savedIcon} {props.savedText || 'Saved'}
            </div>
        </div>
    )
};
